import { useMemo } from 'react'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import { ActionTypes } from './actions'
import { RootState } from './reducers'
import { AppStore } from './store'

type ActionFunction = (...args: any[]) => ActionTypes

export const useActions = <T extends ActionFunction[]>(...actions: T): T => {
  const dispatch = useDispatch()

  // @ts-expect-error
  return useMemo(() => actions.map((a) => bindActionCreators(a, dispatch)), [])
}

export const useActionless = <T extends ActionTypes['type'][]>(...types: T) => {
  type Actions = {
    // @ts-ignore
    [Index in keyof T]: Extract<ActionTypes, { type: T[Index] }>['payload'] extends never
      ? () => Dispatch<Extract<ActionTypes, { type: T[Index] }>>
      : (
          // @ts-ignore
          payload: Extract<ActionTypes, { type: T[Index] }>['payload'],
        ) => Dispatch<Extract<ActionTypes, { type: T[Index] }>>
  }

  // @ts-expect-error
  const dispatch = useDispatch<AppStore>()

  // @ts-expect-error
  return useMemo(() => types.map((type) => (payload) => dispatch({ payload, type })), []) as Actions
}

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
